import { InjectionToken } from "@angular/core";
import { IConnectionCodeService } from "./i-connection-code.service";

export const connectionCodeServiceInjectionToken: InjectionToken<IConnectionCodeService> =
  new InjectionToken<IConnectionCodeService>('digital-signage.user-dashboard.dashboard-web.ConnectionCodeService');
